import React from 'react';

const LizWolfe = () => {
  return (
    <section className="py-20" style={{ background: 'linear-gradient(to bottom right, #E2F9A9, #f5f5f4, #E2F9A9)' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Image */}
          <div className="flex-shrink-0">
            <div className="relative">
              <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden shadow-2xl border-4 border-white">
                <img
                  src="https://customer-assets-0z36b82j.emergentagent.net/job_4614a4a9-8736-46ee-9333-eb2268a85e9b/artifacts/i9wz46it_IMG_1916.jpeg"
                  alt="Liz Wolfe, NTP, CPT, Founder, Ideal Age"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-4 -left-4 w-24 h-24 rounded-full blur-xl" style={{ backgroundColor: 'rgba(226, 249, 169, 0.4)' }} />
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-stone-300/30 rounded-full blur-xl" />
            </div>
          </div>

          {/* Quote */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-block mb-6">
              <svg 
                className="w-12 h-12 opacity-60" 
                fill="#E2F9A9" 
                viewBox="0 0 24 24"
              >
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>
            </div>
            
            <blockquote className="text-2xl md:text-3xl lg:text-4xl font-serif text-stone-800 leading-relaxed mb-8">
              Here are my favorites for supporting your wellness goals - and for taking your next chapter to the next level after 40!
            </blockquote>
            
            <div className="flex flex-col items-center lg:items-start gap-1">
              <p className="text-lg font-semibold text-stone-900">
                Liz Wolfe
              </p>
              <p className="text-sm text-stone-500 tracking-wide">
                NTP, CPT & Founder of Ideal Age
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LizWolfe;
